import * as React from "react";
import { ConnectProto } from "@racoon/api";
import { fullName } from "~/shared/helpers";
import { useListUsersQuery } from "./user.grpc";

/**
 * The organization's active drivers as `{ id, name }` options — what the shift
 * modal's driver select takes. Skipped while there is no organization yet.
 */
export const useActiveDriverOptions = (
  organizationId: string | number | bigint | null | undefined,
  { skip = false }: { skip?: boolean } = {},
) => {
  const { currentData } = useListUsersQuery(
    {
      ownerOrganizationIds: organizationId ? [BigInt(organizationId)] : [],
      roles: [ConnectProto.UserRole.DRIVER],
      statuses: [ConnectProto.UserStatus.ACTIVE],
    },
    { skip: skip || !organizationId },
  );
  return React.useMemo(
    () =>
      (currentData?.users ?? []).map((driver) => ({
        id: String(driver.id),
        name: fullName(driver),
      })),
    [currentData],
  );
};
